<template>
  <div class="slider clearfix">
    <div class="col-1 arrow">
      <div class="icon-frecciaSx" v-on:click="setSliderSx" v-if="page>1">
        <img src="../../../static/image/back.png">
      </div>
    </div>
    <transition name="slide-fade">
      <div class="col-10 slider-container" v-if="show_element_slider">
        <slot :name="'slide-' + (i+((page-1)*n_products_move))" v-for="(p, i) in n_products"></slot>
      </div>
    </transition>
    <div class="col-1 arrow">
      <div class="icon-frecciaDx" v-on:click="setSliderDx"
           v-if="(((page-1)*n_products_move)+n_products) < total_products">
        <img src="../../../static/image/next.png">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'elm-slider',
    props: {
      n_products: {
        type: Number,
        default: 6
      },
      n_products_move: {
        type: Number,
        default: 3
      },
      reset_visible: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        total_products: Object.keys(this.$slots).length,
        page: 1,
        show_element_slider: this.reset_visible
      }
    },
    methods: {
      setSliderSx: function () {
        this.page--
        this.show_element_slider = !this.show_element_slider
      },
      setSliderDx: function () {
        this.page++
        this.show_element_slider = !this.show_element_slider
      }
    }
  }
</script>

<style lang="less">
  .slider {
    .slide-fade-enter-active {
      transition: all .5s ease;
    }
    .slide-fade-leave-active {
      transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to {
      transform: translateX(10px);
      opacity: 0;
    }
    .arrow {
      font-size: 40px;
      height: 200px;
      line-height: 200px;
      padding: 0px;
      cursor: pointer;
      float: left;
    }
    .slider-container {
      padding: 0px;
      float: left;
      > div {
        float: left;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/global/ElmSlider.vue